import {
  ControladoriaMuiProvider,
  ControladoriaMuiLayout,
} from "../Modulos/Controladoria/layout";

const Controladoria = () => (
  <ControladoriaMuiProvider>
    <ControladoriaMuiLayout />
  </ControladoriaMuiProvider>
);

export default Controladoria;
